module.exports = __webpack_public_path__ + "static/media/pic1.356a169f.jpg";